module.exports = __webpack_public_path__ + "img/mobile-recharge.64f0c9a.svg";